module.exports = __webpack_public_path__ + "img/logo.cdc6d162.svg";